import { SEEKER_PROFILE_API_PATH } from "@/constants/appConstants";

export const profileAPI = async <T>(sections: string): Promise<T | Error> => {
  try {
    const response = await fetch(
      `${SEEKER_PROFILE_API_PATH}/profileDetails?fields=${sections}`,
      {
        method: "GET",
        credentials: "include",
      },
    );

    const data: T = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const masterAPI = async <T>(
  type: string,
  name?: string,
  parentUuids?: string,
  countryIsoCode?: string,
): Promise<T | Error> => {
  try {
    const response = await fetch(
      `${SEEKER_PROFILE_API_PATH}/getMasterData?type=${type}${name ? `&name=${name}` : ""}${parentUuids ? `&parentUuids=${parentUuids}` : ""}${countryIsoCode ? `&countryIsoCode=${countryIsoCode}` : ""}`,
      {
        method: "GET",
        credentials: "include",
      },
    );

    const data: T = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};
